import { v4 as uuid } from "uuid";
import axios from "axios";
import { encodeJSON } from "../utils/encoding";

import config from '../config.json';

export const generateLoginPath = (redirect = "/") => {
    const state = { redirect, secret: uuid() };

    const encodedState = encodeJSON(state);

    localStorage.setItem("discord-oauth-state", encodedState);

    const params = new URLSearchParams({
        client_id: "1060020347732250684",
        redirect_uri: config.redirectURI,
        response_type: "code",
        scope: "identify guilds",
        state: encodedState
    });

    return axios.getUri({url: "https://discord.com/api/oauth2/authorize", params});
}
